import { AxiosResponse } from 'axios';

import { IDeleteDriversRequestFilters } from 'models/http/drivers';
import { prepareFiltersOfSelection, prepareQPFromFilters, serverAxios } from '../../http';
import { HTTP } from './core.http';
import {
  ICreateParentResponse,
  IDeleteParentsResponse,
  IGetParentsFilters,
  IGetParentsResponse,
  IGetSingleParentResponse,
  IUpdateParentRequest,
  IUpdateParentResponse,
} from 'models/http/parents';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { IGetHistoryResponse } from 'models/http/history';

class ParentHttp implements HTTP<IDeleteDriversRequestFilters> {
  public static route = '/parents';

  public async get(filters?: IGetParentsFilters, abortController?: AbortController): Promise<IGetParentsResponse> {
    const query = prepareQPFromFilters(filters || {});

    return serverAxios
      .get(`${ParentHttp.route}?${query.toString()}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetParentsResponse>) => response?.data);
  }

  public async delete(ids: number[]): Promise<IDeleteParentsResponse>;
  public async delete(filters: IDeleteDriversRequestFilters): Promise<IDeleteParentsResponse>;
  public async delete(filters: number[] | IDeleteDriversRequestFilters): Promise<IDeleteParentsResponse> {
    return serverAxios
      .delete(ParentHttp.route, {
        data: prepareFiltersOfSelection(filters),
      })
      .then((response: AxiosResponse<IDeleteParentsResponse>) => {
        return response.data;
      });
  }

  public async getById(id: string, abortController?: AbortController): Promise<IGetSingleParentResponse> {
    return serverAxios
      .get(`${ParentHttp.route}/single/${id}`, {
        timeout: HttpTimeoutPriority.Medium,
        signal: abortController?.signal,
      })
      .then((response: AxiosResponse<IGetSingleParentResponse>) => {
        return response.data;
      });
  }

  public async create(data: IUpdateParentRequest): Promise<string> {
    return serverAxios
      .post(ParentHttp.route, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<ICreateParentResponse>) => {
        return response.data.id;
      });
  }

  public async update(id: number, data: IUpdateParentRequest): Promise<IUpdateParentResponse> {
    return serverAxios
      .put(`${ParentHttp.route}/${id}`, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IUpdateParentResponse>) => {
        return response.data;
      });
  }

  public async history(id: string, abortController?: AbortController): Promise<IGetHistoryResponse> {
    return serverAxios
      .get(`${ParentHttp.route}/${id}/history`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Highest,
      })
      .then((response: AxiosResponse<IGetHistoryResponse>) => response.data);
  }
}

export default ParentHttp;
